// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './vuex/store'
import {getUrlParam} from './tools/getUrlParams'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import imagePreview from 'src/components/dialog-image-preview-common/image-preview'
import DialogImagePreviewCommon from 'src/components/dialog-image-preview-common/dialogImagePreviewCommon'
import clickOutside from 'src/directives/click-outside'
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(Viewer)
Vue.component('dialog-image-preview-common', DialogImagePreviewCommon)
Vue.directive('imagePreview', imagePreview)
Vue.directive('click-outside', clickOutside)

// const token = getUrlParam('token')
let token = localStorage.token

if (process.env.NODE_ENV === 'development' && !token) {
  token = getUrlParam('token') || 'MTNlYzhlNjZlMDdlZTYxODg5OTYyYzQwMTA4ODU0ODBkZTYyYmI1YzNiZjdiMmE3MWZkZDMwMTQ1ZWE1YTEyNA'
}

store.commit('UPDATE_TOKEN', token)
// 设置全局携带
// 请求拦截（配置发送请求的信息）
axios.interceptors.request.use(function (config) {
  // 处理请求之前的配置
  config.headers.Authorization = 'Bearer ' + store.state.token
  return config
}, function (error) {
  // 请求失败的处理
  return Promise.reject(error)
})

// 响应拦截（配置请求回来的信息）
axios.interceptors.response.use(function (response) {
  // 处理响应数据
  return response
}, function (error) {
  // 处理响应失败
  return Promise.reject(error)
})

Vue.prototype.showMessage = function (message, type = 'warning', showClose = true) {
  this.$message({
    showClose,
    message,
    type
  })
}

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js